// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import { apiRequest, handleCall } from 'syft-acp-core/api/call'

/**
 * Retrieves a list of point transactions for a worker. Implements pagination.
 *
 * @param workerID {Number} Worker ID
 * @param options {Object} Other query options (e.g., page)
 */
export const fetchPointTransactions = ({ workerID, options = {} }) =>
  new Promise((resolve, reject) => {
    const req = apiRequest({
      path: `/admin/status_program/workers/${workerID}/point_transactions`,
      reqArgs: options,
    })
    handleCall(req, resolve, reject, true, options)
  })
